<template>
  <div class="team-detail">
    <b-alert show>{{ teamDetail }}</b-alert>
  </div>
</template>
<script>
export default {
  props: ["teamDetail"],
  name: "ViewTeamDetail",
};
</script>
